import request from "../utils/request-axios";
import api from "../utils/api";

//统计数据
export function getCountBoard(params) {
  return request(`${api.getCountBoard}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}



// WEBPACK FOOTER //
// ./src/services/dataBoard.js